import { WixConnect } from 'shared/utils/wix-connect';
import { FormattedMessage } from 'react-intl';

import SearchImage from './images/search.svg';

import styles from './empty-search-results.styl';

import widgetTranslations from 'widget/translations';


@WixConnect(styles)
export default class EmptySearchResults extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
  };

  render() {
    return (
      <div className={this.props.className}
           styleName="no-search-wrapper">
        <SearchImage styleName="no-search-icon" />
        <FormattedMessage {...widgetTranslations.noSearchResults}
                          styleName="no-search-text" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/empty-search-results/empty-search-results.js